<template>
  <div class="wgj-item">
    <div class="content">
      <div class="content-text">
        <p class="content-title">外购件保存位置</p>
      </div>
    </div>
    <div class="content-details">
      <div style="width: 100%;margin-bottom: 6px">
        <el-radio v-model="config.modelWgjSaveType" :label="1" @change="modelSaveTypeChange">每次询问</el-radio>
      </div>
      <div style="width: 100%;display: flex;align-items: center;">
        <el-radio v-model="config.modelWgjSaveType" :label="2" @change="modelSaveTypeChange">使用统一保存目录</el-radio>
        <div class="padding-left-25" style="margin-top: 6px">
          <el-input v-model="config.modelWgjSavePath" style="width: 280px" class="margin-right-20"
                    readonly="readonly"
                    size="small" :disabled="config.modelWgjSaveType==1"/>
          <el-button class="content-operate" size="small" :disabled="config.modelWgjSaveType==1"
                      @click="chooseModelSavePath">更改目录
          </el-button>
          <el-button class="content-operate" size="small"
                      :disabled="config.modelWgjSaveType==1 || !config.modelWgjSavePath"
                      @click="openModelSavePath">打开文件夹
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WinForm} from "@/libs";

export default {
  props: {
    config: { default: {} }
  },
  data() {
    return {}
  },
  methods: {
    modelSaveTypeChange(value) {
      if (value === 1) {
        this.configChange('modelWgjSaveType', value);
      } else if (value === 2 && this.config.modelWgjSavePath) {
        this.configChange('modelWgjSaveType', value)
        this.configChange('modelWgjSavePath', this.config.modelWgjSavePath);
      }
    },
    chooseModelSavePath() {
      if (this.config.modelWgjSaveType == 1) return;
      let res = WinForm.md.openDirectoryDlg(this.config.modelWgjSavePath);
      if (res == "failed") return;
      this.configChange('modelWgjSavePath', res)
    },
    openModelSavePath() {
      if (this.config.modelWgjSaveType == 2 && this.config.modelWgjSavePath) {
        WinForm.md.openDirectory(this.config.modelWgjSavePath);
      }
    },
    configChange(key, value) {
      this.$emit('configChange', key, value);
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  padding: 14px 20px;
  align-items: center;

  .model-role-btn {
    position: absolute;
    padding: 0 10px;
    right: 20px;
    top: 25px;
  }

  .model-role-list-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .model-role-list {
    position: absolute;
    right: 21px;
    top: 53px;
    width: 280px;
    border-radius: 4px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #ccc;
    max-height: 130px;
    overflow: auto;
    z-index: 99;

    li {
      padding: 4px 15px;

      &:hover {
        background-color: #efefef;
      }
    }
  }
}
.content-details {
  display: flex;
  padding: 0 10px 10px 50px;
  align-items: center;
  flex-wrap: wrap;
}
.content-operate {
  align-items: center;
  vertical-align: middle;
}
</style>
